import React from 'react';
import { FaBarcode, FaExclamationTriangle, FaRedoAlt } from 'react-icons/fa';

import {
  Container,
  IconCircle,
  Title,
  Description,
  Actions,
  ActionButton
} from './styles';

/*
 * Estado sem boletos na tela. Separa dois casos que parecem iguais para o
 * aluno mas não são: "você não tem boleto" (definitivo) e "não conseguimos
 * buscar" (temporário, vale tentar de novo).
 */
export default function EmptyState({ variant = 'empty', onRetry }) {
  const isError = variant === 'error';

  return (
    <Container>
      <IconCircle variant={variant}>
        {isError ? (
          <FaExclamationTriangle size={36} />
        ) : (
          <FaBarcode size={40} />
        )}
      </IconCircle>

      <Title>
        {isError
          ? 'Não foi possível carregar seus boletos'
          : 'Nenhum boleto por aqui'}
      </Title>

      <Description>
        {isError
          ? 'Pode ter sido uma instabilidade momentânea. Tente novamente em alguns instantes — se continuar, fale com a gente pelo "Fale conosco".'
          : 'Você não tem boletos disponíveis neste momento. Quando um boleto for emitido para você, ele aparece automaticamente nesta página.'}
      </Description>

      {isError && typeof onRetry === 'function' && (
        <Actions>
          <ActionButton type="button" onClick={onRetry}>
            <FaRedoAlt size={14} />
            Tentar novamente
          </ActionButton>
        </Actions>
      )}
    </Container>
  );
}
